import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Fuse from "fuse.js";
import OrderTable from './Components/OrderTable';
import { Menu, IconButton, InputLabel, Box, Typography, Button, Grid, TextField, InputAdornment, Dialog, DialogContent, DialogTitle, DialogActions, Alert, Chip, CircularProgress, DialogContentText, Select, MenuItem, FormControl, Divider, OutlinedInput, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { JobDetails3, JobData2 } from '../../store/types';
import { useDispatch, useSelector } from 'react-redux';
import { setTotalJobNumber, setTotalPageNumber, setCurrentPageNumber } from "../../store/page/jobPageSlice";
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import csv from '../../assets/csv.png';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { JobEnums } from '../../utils/enums/JobEnums';
import { DEFAULT_LOCATION_LIMIT } from '../../hooks/location';
import SSUChart from './Components/SSUChart';
import DPChart from './Components/DPChart';
import { COLOR } from '../../utils/colors';
import { getMaxEndDate } from '../../lib/api/function';
import { TimeNumberProps } from '../jobs/Components/_type';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { DEFAULT_DATEFORMAT, removeEmptyValues } from '../scheduledJob/_function/common';
import { RobotTaskResponse, RobotTaskType } from '../../hooks/robotTask/index.type';
import { useJobList } from '../../hooks/job';
import { JobResponse } from '../../hooks/job/index.type';
import JobFilterDialog, { FilterResponseType } from '../jobs/Components/JobFilter';
import { parseAsInteger, parseAsIsoDate, useQueryState } from 'nuqs';
import { customLog, underscoreToSpace } from '../../utils/utils';
import { customAxios } from '../../lib/axios';
import { useAnalyticsCard, useCreateAnalyticsCardMutation, useDeleteAnalyticsCardMutation, useEditAnalyticsCardMutation, useShowAnalytics, useUpdateAnalyticsLayoutMutation } from '../../hooks/analytics';
import NewCustomAnalyticDialog, { CardType, CustomCardProps } from '../jobs/Components/NewCustomAnalytic';
import GridLayout, { Responsive, WidthProvider } from "react-grid-layout";
import { Switch } from '../../components/Switch';
import CustomCard from '../jobs/Components/CustomCard';
import { DYNAMIC_WIDGET_ENABLED } from '../../utils/const';

const ResponsiveGridLayout = WidthProvider(Responsive);


interface GeneralRobotInfo {
  robot_name: string;
  robot_mac: string;
  robot_serial_number: string;
  robot_type: string;
  organisation_name: string;
  organisation: string;
}

interface columnType {
  id: string;
  label: string;
  padding?: string;
}

interface Duration {
  start_time: number;
  end_time: number;
}

type TimeOptionType = {
  name: string,
  value: {
    time: number,
    unit: dayjs.ManipulateType
  }
}

const timeOptions: TimeOptionType[] = [{
  name: "Yesterday",
  value: {
    time: 1,
    unit: 'days'
  }
}, {
  name: "Today",
  value: {
    time: 0,
    unit: 'days'
  }
}, {
  name: "Past 3 days",
  value: {
    time: 3,
    unit: 'days'
  }
}, {
  name: "Past 7 days",
  value: {
    time: 7,
    unit: 'days'
  }
}, {
  name: "Past 2 weeks",
  value: {
    time: 14,
    unit: 'days'
  }
}, {
  name: "Custom",
  value: {
    time: 14, //Dummy
    unit: 'days' //Dummy
  }
}]

const defaultTime: TimeOptionType = {
  name: "Past 7 days",
  value: {
    time: 7,
    unit: 'days'
  }
}

const OrderHistory: React.FC = () => {
  const [jobs, setJobs] = useState<JobData2>({});
  const [filteredJobs, setFilteredJobs] = useState<JobData2>({});
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterDialogOpen, setFilterDialogOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const pageSize = useSelector((state: any) => state.jobPage.jobsPerPage);
  const pageNumber = useSelector((state: any) => state.jobPage.currentPageNumber);
  const [reportId, setReportId] = useState<number>(0);
  const [duration, setDuration] = useState<Duration>({ start_time: 0, end_time: 0 });
  const [statusFilter, setStatusFilter] = useQueryState("status", { defaultValue: 'all' });
  const [startLocationFilter, setStartLocationFilter] = useQueryState("start_location", { defaultValue: 'all' });
  const [endLocationFilter, setEndLocationFilter] = useQueryState("end_location", { defaultValue: "all" });
  const [robotFilter, setRobotFilter] = useQueryState("robot", { defaultValue: 'all' });
  const [appliedFilters, setAppliedFilters] = useState<{ label: string; value: string; key: string }[]>([]);
  const [isExporting, setIsExporting] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [exportType, setExportType] = useState<string>("simplified");
  const [robots, setRobots] = useState<{ [robot_mac: string]: { generalInfo: GeneralRobotInfo } }>({});
  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [rowsPerPage, setRowsPerPage] = useQueryState("limit", parseAsInteger.withDefault(10));
  const [selectedTime, setSelectedTime] = useState<string>(defaultTime.name)
  const [selectedTimeValue, setSelectedTimeValue] = useState<number>(defaultTime.value.time)
  const [selectedTimeUnit, setSelectedTimeUnit] = useState<dayjs.ManipulateType>(defaultTime.value.unit)

  const [jobListCacheKey, setJobListCacheKey] = useState('')
  const [startGraphDate, setStartGraphDate] = useState<Dayjs | null>(null);
  const [endGraphDate, setEndGraphDate] = useState<Dayjs | null>(null);

  const [isLoading, setIsLoading] = useState(false)

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage + 1);
    getJobList(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const pageSize = parseInt(event.target.value, 10);
    setRowsPerPage(pageSize);
    setPage(1);
    getJobList(1, pageSize);
  };

  const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectExportType = (type: string) => {
    setExportType(type);
    handleCloseMenu();
    createReport(type);  // Call the createReport function with the selected type
  };

  const jobsColumn: columnType[] = [
    { id: 'order_number', label: 'Order No.', padding: "15px 20px" },
    { id: 'job_id', label: 'Job No.', padding: "15px 20px" },
    { id: 'job_type', label: 'Job Type', padding: "15px 20px" },
    { id: 'robot_name', label: 'Robot Name', padding: "15px 20px" },
    // { id: 'load_compartment', label: 'Compartment', padding: "15px 20px" },
    { id: 'sender_location', label: 'From' },
    { id: 'recipient_location', label: 'To' },
    { id: 'status', label: 'Status' },
    { id: 'duration', label: 'Duration' },
    { id: 'created_at', label: 'Created Time' },
    { id: 'timestamp', label: 'Completed Time' },
  ];

  const createReport = async (reportType: string) => {
    const startTime = duration.start_time === 0 ? "" : duration.start_time;
    const endTime = duration.end_time === 0 ? "" : duration.end_time;

    await customAxios({
      method: "POST",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/job_list/generate_report/`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      data: removeEmptyValues({
        start_time: startTime,
        end_time: endTime,
        status: statusFilter?.toLowerCase() === "all" ? "" : statusFilter,
        start_location: startLocationFilter?.toLowerCase() === "all" ? "" : startLocationFilter,
        end_location: endLocationFilter?.toLowerCase() === "all" ? "" : endLocationFilter,
        report_type: reportType,
        robot_name: robotFilter?.toLowerCase() === "all" ? "" : robotFilter,
      })
    }).then((response) => {
      if (response.status === 200) {
        setReportId(response.data.report_id);
        setIsExporting(true);
        setTimeout(() => {
          setIsExporting(false);
          navigate(`/reports`);
        }, 8000);
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  const getJobList = async (pageNumber: number, pageSize: number, response?: FilterResponseType) => {
    const dataParams = removeEmptyValues({
      page: pageNumber,
      page_size: pageSize,
      status: statusFilter === "all" ? "" : statusFilter,
      start_time: !startDate ? "" : startDate.unix(),
      end_time: !endDate ? "" : endDate.unix(),
      start_location: startLocationFilter?.toLowerCase() === "all" ? "" : startLocationFilter,
      end_location: endLocationFilter?.toLowerCase() === "all" ? "" : endLocationFilter,
      robot_name: robotFilter?.toLowerCase() === "all" ? "" : robotFilter,
    })

    const encodeCacheKey = JSON.stringify(dataParams)
    if (!!jobs && encodeCacheKey === jobListCacheKey) {
      return
    }
    setIsLoading(true)
    setJobListCacheKey(encodeCacheKey)

    await customAxios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/job_list/`,
      // url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/job_list/?page=${pageNumber}&page_size=${pageSize}&start_time=${duration.start_time === 0 ? "" : duration.start_time}&end_time=${duration.end_time === 0 ? "" : duration.end_time}&status=${statusFilter === "all" ? "" : statusFilter}&start_location=${startLocationFilter === "All" ? "" : startLocationFilter}&end_location=${endLocationFilter === "All" ? "" : endLocationFilter}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      params: dataParams,
    }).then((response) => {
      setIsLoading(false)
      if (response.status === 200) {
        dispatch(setTotalJobNumber(response.data.count));
        dispatch(setTotalPageNumber(response.data.num_pages));
        dispatch(setCurrentPageNumber(response.data.current_page));
        setJobs(response.data.data.reduce((acc: JobData2, job: JobDetails3) => {
          acc[job.job_id] = job;
          return acc;
        }, {}));
        customLog("Jobs:", response.data.data);
      }
    }).catch((error) => {
      setIsLoading(false)
      console.error(error);
    });
    setIsLoading(false)
  }
  const queryRobots = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/v1/rms/robot/`, {
        headers: { "Authorization": `Bearer ${localStorage.getItem('accessToken')}` },
      });
      const robotsData = await Promise.all(data.data.map(async (robot: GeneralRobotInfo) => {
        customLog("Robot:", robot);
        // const organisationName = await getOrganisation(robot.organisation);
        return {
          ...robot,
          organisation_name: "Autove",
        };
      }));
      customLog("Robots data:", robotsData);
      const robotsMap = robotsData.reduce((acc, robot) => ({
        ...acc,
        [robot.robot_mac]: {
          generalInfo: {
            robot_name: robot.robot_name,
            robot_mac: robot.robot_mac,
            robot_serial_number: robot.robot_serial_number,
            robot_type: robot.robot_type,
            organisation: robot.organisation_name,
          },
        },
      }), {});
      customLog("Robots map:", robotsMap);
      setRobots(robotsMap);
    } catch (error) {
      console.error("Failed to fetch robots:", error);
    }
  };

  const fuseOptions = {
    keys: ["job_id"],
    includeScore: true
  };

  const fuse = new Fuse(Object.values(jobs), fuseOptions);

  useEffect(() => {
    queryRobots();
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const results = fuse.search(searchTerm).map(result => result.item);
      setFilteredJobs(Object.fromEntries(results.map(job => [job.job_id, job])));
    } else {
      setFilteredJobs(jobs);
    }
  }, [searchTerm, jobs]);

  const [applySubmitted, setApplySubmitted] = useState(false);

  const handleApplyFilters = () => {
    const newFilters = [];

    if (statusFilter && statusFilter?.toLowerCase() !== 'all') {
      newFilters.push({ label: `Status: ${statusFilter}`, value: statusFilter, key: 'statusFilter' });
    }
    if (startLocationFilter && startLocationFilter?.toLowerCase() !== "all") {
      newFilters.push({ label: `Start Location: ${startLocationFilter}`, value: startLocationFilter, key: 'startLocationFilter' });
    }
    if (endLocationFilter && endLocationFilter?.toLowerCase() !== "all") {
      newFilters.push({ label: `End Location: ${endLocationFilter}`, value: endLocationFilter, key: 'endLocationFilter' });
    }
    if (robotFilter && robotFilter?.toLowerCase() !== "all") {
      newFilters.push({ label: `Robot Name: ${robotFilter}`, value: robotFilter, key: 'robotFilter' });
    }
    if (startDate || endDate) {
      const formattedStartDate = startDate ? dayjs(startDate).format('DD/MM/YYYY') : '';
      const formattedEndDate = endDate ? dayjs(endDate).format('DD/MM/YYYY') : dayjs().format('DD/MM/YYYY');
      newFilters.push({ label: `Date Range: ${formattedStartDate} - ${formattedEndDate}`, value: "", key: 'dateRange' });
      if (!!startDate) {
        const end = endDate ? endDate : dayjs();
        setDuration((prev) => ({ ...prev, start_time: dayjs(startDate).unix(), end_time: end.endOf('day').unix() }));
      }
    }
    getJobList(1, pageSize)
    setAppliedFilters(newFilters);
    setApplySubmitted(true);
    setFilterDialogOpen(false);
    dispatch(setCurrentPageNumber(1));
    setPage(1);
  };

  useEffect(() => {
    handleApplyFilters()
  }, [robotFilter, statusFilter, startLocationFilter, endLocationFilter, startDate, endDate])

  const handleDeleteChip = (key: string) => {
    setAppliedFilters((prevFilters) => prevFilters.filter(filter => filter.key !== key));

    // Reset the filter state values based on the deleted chip key
    if (key === 'statusFilter') {
      setStatusFilter("all");
    }
    if (key === 'startLocationFilter') {
      setStartLocationFilter("all");
    }
    if (key === 'endLocationFilter') {
      setEndLocationFilter("all");
    }
    if (key === 'dateRange') {
      setStartDate(null);
      setEndDate(null);
      setDuration({ start_time: 0, end_time: 0 });
    }

    if (key === 'robotFilter') {
      setRobotFilter("all");
    }

    getJobList(1, pageSize)
  };

  const handleStartDateChange = (newStartDate: Dayjs | null) => {
    const today = dayjs();
    if (!newStartDate || !dayjs.isDayjs(newStartDate) || newStartDate.isAfter(today)) {
      setStartDate(null);
      setDuration((prev) => ({ ...prev, start_time: 0 }));
      return;
    }
    const startOfDay = dayjs(newStartDate).startOf('day');
    setStartDate(startOfDay);
    setDuration((prev) => ({ ...prev, start_time: startOfDay.unix() }));

    if (endDate && endDate.add(3, 'month').startOf('day').isAfter(startOfDay)) {
      setEndDate(null)
    }
  };

  // useEffect(() => {
  //   customLog("Fetching job list with filters:", duration, statusFilter, startLocationFilter, endLocationFilter);
  //   getJobList(1, pageSize);
  // }, [appliedFilters]);

  useEffect(() => {
    if (!selectedTime) {
      return
    }

    const findData = timeOptions.find((item) => item.name.toLowerCase() === selectedTime.toLowerCase())

    if (!findData) {
      return
    }

    setSelectedTimeValue(findData.value.time)
    setSelectedTimeUnit(findData.value.unit)
  }, [selectedTime])

  const handleStartGraphDateChange = (newStartDate: Dayjs | null) => {
    const today = dayjs();
    if (!newStartDate || !dayjs.isDayjs(newStartDate) || newStartDate.isAfter(today)) {
      setStartGraphDate(null);
      return;
    }
    const startOfDay = dayjs(newStartDate).startOf('day');
    setStartGraphDate(startOfDay);
  };

  const handleEndGraphDateChange = (newEndDate: Dayjs | null) => {
    const today = dayjs();
    if (!newEndDate || !dayjs.isDayjs(newEndDate) || newEndDate.isAfter(today)) {
      setEndGraphDate(null);
      // setDuration((prev) => ({ ...prev, end_time: 0 }));
      return;
    }
    const endOfDay = dayjs(newEndDate).endOf('day');
    setEndGraphDate(endOfDay);
  };

  const handleSelectTime = (value: string) => {
    if (!value.toLowerCase().includes('custom')) {
      setStartGraphDate(null)
      setEndGraphDate(null)
    }
    setSelectedTime(value)
  }

  const getStartEndTime = (): TimeNumberProps => {
    if (!selectedTime.toLowerCase().includes('custom')) {
      return {
        startTime: parseInt((dayjs().subtract(selectedTimeValue, selectedTimeUnit).startOf('day').valueOf() / 1000).toString()),
        endTime: parseInt((dayjs().endOf('day').valueOf() / 1000).toString()),
      }
    }

    if (!startGraphDate || !endGraphDate) {
      return {
        startTime: parseInt((dayjs().subtract(defaultTime.value.time, defaultTime.value.unit).startOf('day').valueOf() / 1000).toString()),
        endTime: parseInt((dayjs().endOf('day').valueOf() / 1000).toString()),
      }
    }

    return {
      startTime: parseInt((startGraphDate.startOf('day').valueOf() / 1000).toString()),
      endTime: parseInt((endGraphDate.endOf('day').valueOf() / 1000).toString())
    }
  }

  const paperRef = useRef<HTMLDivElement | null>(null);

  const exportPDF = () => {
    if (!paperRef.current) {
      console.error('Paper reference is not available');
      return;
    }

    html2canvas(paperRef.current, { scale: 2, logging: true, useCORS: true })
      .then(canvas => {
        customLog('Canvas Size:', canvas.width, canvas.height);

        const imgData = canvas.toDataURL('image/jpeg', 0.3);

        // Set custom dimensions for a wider format
        const pdfWidth = 1920;  // Example width in px for a wider layout
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;  // Maintain aspect ratio

        const pdf = new jsPDF({
          orientation: 'l',  // 'l' stands for landscape
          unit: 'px',
          format: [pdfWidth, pdfHeight], // Set custom size
        });

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`Order Analytics ${Date.now().toString()}.pdf`);
      })
      .catch(error => {
        console.error('Error generating PDF:', error);
      });
  };

  const [pageGraph, setPageGraph] = useState(1)
  const [dataPages, setDataPages] = useState<JobResponse[]>([])

  const { isShowAnalytics } = useShowAnalytics();

  const { startTime, endTime } = getStartEndTime();
  const { data: dataJobGraph, isLoading: isLoadingGraph, refetch: refetchGraph } = useJobList({
    page: pageGraph,
    page_size: 100,
    start_time: startTime,
    end_time: endTime,
    start_location: 'all'
  })

  useEffect(() => {
    if (!dataJobGraph || isLoadingGraph) {
      return
    }

    const currentPage = dataJobGraph.current_page
    if (dataJobGraph.current_page === 1 || dataPages.length === 0) {
      setDataPages([dataJobGraph])
    } else {
      const findPageIndex = dataPages.findIndex((data) => data.current_page === currentPage)
      const tmpData = [...dataPages]
      // If Data Found
      if (findPageIndex >= 0) {
        tmpData.splice(findPageIndex, 1)
      }

      tmpData.push(dataJobGraph)
      setDataPages(tmpData)
    }

    if (currentPage < dataJobGraph.num_pages) {
      setPageGraph(page + 1)
    }

  }, [dataJobGraph])

  const current_page = dataJobGraph?.current_page || 1
  const dataGraphs = dataPages.map((item) => [...item.data]).flat(1)

  useEffect(() => {
    if (isLoadingGraph || !dataJobGraph) {
      return
    }
    if (pageGraph === 1 && current_page === pageGraph) {
      refetchGraph()
    }
    setDataPages([])
    setPageGraph(1)

  }, [startTime, endTime])

  useEffect(() => {
    if (isLoadingGraph || !dataJobGraph) {
      return
    }
    refetchGraph()
  }, [pageGraph])

  const handleResetFilters = () => {
    // Reset the filter state values based on the deleted chip key
    setDuration({ start_time: 0, end_time: 0 });
    setStatusFilter("all");
    setStartLocationFilter("All");
    setEndLocationFilter("All");
    setRobotFilter("All");
    setStartDate(null);
    setEndDate(null);
    setStartDate(null)
    setEndDate(null)
    setAppliedFilters([]);
    setApplySubmitted(true);
    setFilterDialogOpen(false);
    setPage(1);
  }

  const { data: dataListAnalytics, refetch: refetchAnalytics, error: errorAnalytics } = useAnalyticsCard({ page: 'order', enabled: isShowAnalytics });
  const cardList = (!!dataListAnalytics && Array.isArray(dataListAnalytics)) ? dataListAnalytics : [];
  const isCardEnabled =  (!!dataListAnalytics && Array.isArray(dataListAnalytics))

  const cardData: CardType[] = cardList.map((card) => ({
    id: card.uuid,
    x: card.x_position,
    y: card.y_position,
    w: card.width,
    h: card.height,
    minH: card.minHeight,
    option: {
      title: card.title,
      viewType: card.view_type,
      dataType: card.data_type || 'bar_chart',
      filters: card.filters.map((filter) => ({
        value: filter.value,
        filterValue: filter.filterValue
      })),
      is_can_edit_card: card.is_can_edit_card,
    }
  }))

  const isErrorAnalytics = Boolean(errorAnalytics);

  const [editCardMode, setEditCardMode] = useState(false);
  const [selectedEditCard, setSelectedEditCard] = useState<CardType | undefined>();
  const [wantToDeleteId, setWantToDeleteId] = useState<string | null>(null);
  const [wantToEditId, setWantToEditId] = useState<string | null>(null);

  const { trigger: updateLayouts } = useUpdateAnalyticsLayoutMutation({
    onSuccess: () => {
      // Refresh Card Data
      refetchAnalytics();
    }
  })

  const { trigger: deleteAnalyticsCard } = useDeleteAnalyticsCardMutation({
    onSuccess: () => {
      // Refresh Card Data
      refetchAnalytics();
    },
    uuid: wantToDeleteId || '',
  })

  const { trigger: createAnalyticsCard } = useCreateAnalyticsCardMutation({
    onSuccess: () => {
      // Refresh Card Data
      refetchAnalytics();
    }
  })

  const { trigger: updateCardAnalytic } = useEditAnalyticsCardMutation({
    onSuccess: () => {
      // Refresh Card Data
      refetchAnalytics();
      setSelectedEditCard(undefined);
    },
    uuid: wantToEditId || '',
  })

  const handleWantToDeleteCard = (uuid: string) => {
    setWantToDeleteId(uuid);
  }

  const [openNewCard, setOpenNewCard] = useState(false);
  const handleOpenNewCard = () => {
    setOpenNewCard(true);
  };

  const handleCloseNewCard = () => {
    setOpenNewCard(false);
  };


  const handleSubmitNewCard = (data: CustomCardProps) => {
    customLog('New Card Data:', data);
    const newY = cardData.length > 0 ? Math.max(...cardData.map(card => card.y + card.h)) : 0;

    createAnalyticsCard({
      page_type: "order",
      view_type: data.viewType,
      data_type: data.dataType,
      title: data.title,
      x_position: 0,
      y_position: newY || 0,
      width: 6,
      height: 8,
      filters: data.filters.map((filter) => ({
        value: filter.value,
        filterValue: filter.filterValue
      }))
    })
    // setCardData([...cardData, newCard]);
    setOpenNewCard(false);
  }

  const handleUpdateCardLayout = (layouts: GridLayout.Layout[]) => {
    if (!editCardMode) {
      return;
    }
    updateLayouts({
      layouts: layouts.map((layout) => ({
        // UUID is the prefix of layout.i before the last hyphen
        uuid: layout.i.substring(0, layout.i.lastIndexOf('-')),
        x_position: layout.x,
        y_position: layout.y,
        width: layout.w,
        height: layout.h,
      }))
    })
    // setCardData(updatedCards);
  }
  const handleEditCard = (data: CardType) => {
    setSelectedEditCard(data);
    setWantToEditId(data.id);
  }

  const handleCloseEditCard = () => {
    setSelectedEditCard(undefined);
  }


  const handleSubmitEditCard = (data: CustomCardProps) => {
    if (!selectedEditCard) return;

    const updatedCard: CardType = {
      ...selectedEditCard,
      option: data
    };

    // Trigger Save to Backend Here
    updateCardAnalytic({
      page_type: "order",
      view_type: data.viewType,
      data_type: data.dataType,
      title: data.title,
      x_position: updatedCard.x,
      y_position: updatedCard.y,
      width: updatedCard.w,
      height: updatedCard.h,
      filters: data.filters.map((filter) => ({
        value: filter.value,
        filterValue: filter.filterValue
      }))
    })
  };

  const handleDeleteCard = (data: CardType) => {
    // Trigger Delete to Backend Here

    // const updatedCards = cardData.filter(card => card.id !== data.id);
    // setCardData(updatedCards);

    deleteAnalyticsCard()
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} >
      <Box sx={{ maxWidth: "95%", m: "15px auto", height: "100%", }}>
        <Box sx={{ display: "flex", mb: "15px", justifyContent: "space-between", alignItems: "center", margin: "15px auto" }}>
          <Typography variant="h4" sx={{ color: "black" }}>Orders</Typography>
          {isShowAnalytics && (
            <Button onClick={exportPDF} variant='contained'>Export Analytics PDF</Button>
          )}
        </Box>
        {isShowAnalytics && (
          <>
            <Paper ref={paperRef} sx={{ display: "flex", flexDirection: 'column', justifyContent: "right", margin: "15px auto", padding: '16px' }}>
              <Box sx={{ width: '100%', display: "flex", mb: "15px", justifyContent: "space-between", alignItems: "center", margin: "8px auto" }}>
                <Typography variant="h5" sx={{ color: "black" }}>Analytic</Typography>
                <Box sx={{ display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: "right", gap: '12px' }}>
                  {DYNAMIC_WIDGET_ENABLED && isCardEnabled && (
                    <Box sx={{ display: 'flex', flexDirection: 'row', height: '100%', gap: '4px' }}>
                      <Typography sx={{ alignSelf: 'center' }}>Edit Mode</Typography>
                      <Switch checked={editCardMode} onCheckedChange={(val) => setEditCardMode(val)} />
                    </Box>
                  )}
                  <Select
                    size='small'
                    displayEmpty
                    value={selectedTime}
                    onChange={(e) => handleSelectTime(e.target.value)}
                    input={<OutlinedInput />}
                    renderValue={(selected: string) => {
                      if (!selected) {
                        return <em>Placeholder</em>;
                      }

                      return selected
                    }}
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    {timeOptions.map((time: TimeOptionType) => (
                      <MenuItem
                        key={time.name}
                        value={time.name}
                        sx={{ textTransform: 'capitalize' }}
                      >
                        {time.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {selectedTime?.toLowerCase().includes('custom') && (
                    <Box sx={{ maxWidth: '350px', display: 'flex', gap: '2px', justifyContent: 'space-between' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <DatePicker
                          label="Start Date"
                          value={startGraphDate}
                          onChange={handleStartGraphDateChange}
                          maxDate={dayjs()}
                          format={DEFAULT_DATEFORMAT}
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px' }}>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>-</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <DatePicker
                          label="End Date"
                          value={endGraphDate}
                          onChange={handleEndGraphDateChange}
                          minDate={startGraphDate || undefined}
                          maxDate={dayjs()}
                          format={DEFAULT_DATEFORMAT}

                        />
                      </Box>
                    </Box>
                  )}
                  {editCardMode && (
                    <Box sx={{ flex: 'none', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
                      <Button onClick={() => handleOpenNewCard()} variant="contained">
                        Add New Card
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
              {DYNAMIC_WIDGET_ENABLED && isCardEnabled && cardData.length > 0 && (
                <ResponsiveGridLayout
                  breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                  cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                  style={{ marginBottom: '15px' }} rowHeight={30} width={1200}
                  onLayoutChange={(layouts) => handleUpdateCardLayout(layouts)}
                  useCSSTransforms={true}
                  isDraggable={editCardMode}
                  isResizable={editCardMode}
                >
                  {cardData.map((card, index) => (
                    <div key={card.id + '-' + index} data-grid={{ x: card.x, y: card.y, w: card.w, h: card.h, minW: 2, minH: card.minH || 8 }}>
                      <CustomCard
                        key={card.id + '-' + index}
                        cardData={card}
                        data={dataGraphs as unknown as RobotTaskType[]}
                        isLoading={isLoadingGraph}
                        // startTime={startGraphDate}
                        // endTime={endGraphDate}
                        {...getStartEndTime()}
                        onEdit={() => handleEditCard(card)}
                        onDelete={() => handleDeleteCard(card)}
                        editable={editCardMode}
                        wantToDelete={(id) => handleWantToDeleteCard(id)}
                        cancelDelete={() => setWantToDeleteId(null)}
                      />
                    </div>
                  ))}
                </ResponsiveGridLayout>
              )}
              {DYNAMIC_WIDGET_ENABLED && isCardEnabled && isCardEnabled && cardData.length === 0 && (
                <Box sx={{ width: '100%', display: "flex", justifyContent: "center", alignItems: "center", margin: "15px auto", padding: '40px 0' }}>
                  <Typography variant="h6" sx={{ textAlign: 'center', fontSize: '14px', color: COLOR.gray[400] }}>
                    No Analytic Card. {editCardMode ? 'Click "Add New Card" to create one.' : 'Enable Edit Mode to add Analytic Cards.'}
                  </Typography>
                </Box>
              )}
              {(!DYNAMIC_WIDGET_ENABLED || !isCardEnabled) && (
                <Grid container spacing={2} sx={{ mb: 4 }}>
                  {/* <SSUChart {...getStartEndTime()} data={dataGraphs} isLoading={isLoadingGraph} /> */}
                  <DPChart {...getStartEndTime()} data={dataGraphs} isLoading={isLoadingGraph} />
                </Grid>
              )}
            </Paper>
            <hr style={{ border: `1px solid ${COLOR.gray[200]}`, marginTop: '12px', marginBottom: '12px' }} />
            {DYNAMIC_WIDGET_ENABLED && isCardEnabled && (
              <>
                <NewCustomAnalyticDialog
                  open={openNewCard}
                  handleClose={handleCloseNewCard}
                  handleSubmit={handleSubmitNewCard}
                />

                <NewCustomAnalyticDialog
                  data={selectedEditCard?.option}
                  open={!!selectedEditCard}
                  handleClose={handleCloseEditCard}
                  handleSubmit={handleSubmitEditCard}
                />
              </>
            )}
          </>
        )}
        <Typography variant="h6" sx={{ mb: "10px", color: "black" }}>Order Tables</Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px auto" }}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            value={searchTerm}
            placeholder='Search Order'
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              width: "94%",
              background: "white",
              "& .MuiOutlinedInput-root": {
                height: "40px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            onClick={() => setFilterDialogOpen(true)}
            sx={{ marginLeft: 2, background: "#fff", border: "1px solid #c0c0c0", boxShadow: "none", '&:hover': { background: "#f5f5f5" } }}
          >
            <FilterAltIcon sx={{ color: "#c0c0c0" }} />
          </Button>
          {/* <Button
                        variant="outlined"
                        sx={{ marginLeft: 2 }}
                        onClick={() => createReport()}
                    >
                        Export
                    </Button> */}

          <Button
            variant="contained"
            sx={{ marginLeft: 2 }}
            // onClick={handleExportClick}
            onClick={() => createReport("detailed")}
          // endIcon={<KeyboardArrowDownIcon />}
          >
            Export
          </Button>
          {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={() => handleSelectExportType("simplified")}>Simplified</MenuItem>
            <Divider sx={{ my: 1, width: "95%", m: "auto" }} />
            <MenuItem onClick={() => handleSelectExportType("detailed")}>Detailed</MenuItem>
          </Menu> */}
        </Box>

        {/* Display applied filter chips */}
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2, textTransform: 'capitalize' }}>
          {appliedFilters.map((filter) => (
            <Chip
              key={filter.key}
              label={
                //uppercase the first letter of the filter label
                underscoreToSpace(filter.label)
              }
              onDelete={() => handleDeleteChip(filter.key)}
              sx={{ backgroundColor: "#F1F7FD", color: "#378FFE", border: "1px solid #CEDBFF" }}
            />
          ))}
        </Box>

        {/* Filter Dialog */}
        <JobFilterDialog
          open={filterDialogOpen}
          onChangeOpen={(value) => setFilterDialogOpen(value)}
          selectedRobotName={robotFilter}
          selectedStartLocation={startLocationFilter}
          selectedEndLocation={endLocationFilter}
          selectedStartDate={startDate ? dayjs(startDate) : null}
          selectedEndDate={endDate}
          selectedStatus={statusFilter}
          endDateMonthLimit={6}
          onChangeFilter={
            (param) => {
              const {
                robot,
                status,
                startLocation,
                startDate: currentStartDate,
                endLocation,
                endDate: currentEndDate
              } = param
              if (robot !== robotFilter) {
                setRobotFilter(robot || 'all')
              }

              if (status !== statusFilter) {
                setStatusFilter(status || 'all')
              }

              if (startLocationFilter !== startLocation) {
                setStartLocationFilter(startLocation || 'all')
              }

              if (endLocation !== endLocationFilter) {
                setEndLocationFilter(endLocation || 'all')
              }

              if (startDate !== currentStartDate) {
                setStartDate(currentStartDate || null)
              }

              if (endDate !== currentEndDate) {
                setEndDate(currentEndDate || null)
              }
            }
          }
        />
        <OrderTable columns={jobsColumn} items={filteredJobs} isLoading={isLoading} getJobList={getJobList} page={page > 0 ? page - 1 : page} rowsPerPage={rowsPerPage} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
        <Dialog open={isExporting} onClose={() => setIsExporting(false)}>
          <DialogTitle>Report Generation</DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", alignText: "justify" }} mb={2}>
              <DialogContentText>
                Your file is being generated. Redirecting to the download page in a few seconds...
              </DialogContentText>
              <Box display="flex" flexDirection="row" justifyContent="space-around" alignItems="flex-start" mt={4} sx={{ width: "100%", mb: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "flex-start" }}>
                  <img src={csv} alt="csv" style={{ height: "50px" }} />
                  <Typography component="div" sx={{ ml: 3, fontSize: "16px", mt: 1.5 }}>
                    Report Reference ID: {reportId}
                  </Typography>
                </Box>
                <CircularProgress sx={{ ml: 2 }} />
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </LocalizationProvider>
  );
};

export default OrderHistory;
